import { render, staticRenderFns } from "./SelectPeople.vue?vue&type=template&id=395e2272&scoped=true"
import script from "./SelectPeople.vue?vue&type=script&lang=js"
export * from "./SelectPeople.vue?vue&type=script&lang=js"
import style0 from "./SelectPeople.vue?vue&type=style&index=0&id=395e2272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395e2272",
  null
  
)

export default component.exports